export type MermaidTemplateId =
  | 'blank'
  | 'flowchart'
  | 'sequence'
  | 'class'
  | 'er'
  | 'state'
  | 'gantt';

export type MermaidTemplate = {
  id: MermaidTemplateId;
  name: string;
  source: string;
};

export const DEFAULT_MERMAID_TEMPLATE: MermaidTemplateId = 'flowchart';

export const MERMAID_TEMPLATES: readonly MermaidTemplate[] = [
  {
    id: 'blank',
    name: 'Blank',
    source: 'flowchart TD',
  },
  {
    id: 'flowchart',
    name: 'Flowchart',
    source: 'flowchart TD\n  A[Start] --> B[Process] --> C[Done]',
  },
  {
    id: 'sequence',
    name: 'Sequence',
    source: 'sequenceDiagram\n  Alice->>Bob: Hello\n  Bob-->>Alice: Reply',
  },
  {
    id: 'class',
    name: 'Class',
    source:
      'classDiagram\n  class Example {\n    +String name\n    +run()\n  }',
  },
  {
    id: 'er',
    name: 'ER diagram',
    source: 'erDiagram\n  CUSTOMER ||--o{ ORDER : places',
  },
  {
    id: 'state',
    name: 'State',
    source: 'stateDiagram-v2\n  [*] --> Ready\n  Ready --> Done',
  },
  {
    id: 'gantt',
    name: 'Gantt',
    source:
      'gantt\n  title Project plan\n  dateFormat YYYY-MM-DD\n  section Work\n  Task :a1, 2026-01-01, 3d',
  },
];

export function getMermaidTemplate(id: MermaidTemplateId) {
  return (
    MERMAID_TEMPLATES.find(template => template.id === id) ??
    MERMAID_TEMPLATES[1]
  );
}
